import {
  BATCH_STATUS_OPEN,
  BATCH_STATUS_QUEUED,
  BATCH_STATUS_PROCESSING,
  BATCH_STATUS_GENERATING,
  BATCH_STATUS_COMPLETED,
  BATCH_STATUS_NOTIFYING_MARKETPLACE,
  BATCH_STATUS_SENDING_EMAILS,
  BATCH_STATUS_INVALID,
  BATCH_STATUS_ARCHIVED,
} from '../../../constants/batch-status';

import { defineMessages } from 'react-intl';

const messages = defineMessages({
  openStatus: {
    description: 'Batches Grid (All Statuses) > Batch Status - Open',
    defaultMessage: 'Open',
    id: 'vtpdaK',
  },
  queuedStatus: {
    description: 'Batches Grid (All Statuses) > Batch Status - Queued',
    defaultMessage: 'Queued',
    id: 'ZzZbN7',
  },
  processedStatus: {
    description: 'Batches Grid (All Statuses) > Batch Status - Processed',
    defaultMessage: 'Processed',
    id: 'VJbXoD',
  },
  generatingStatus: {
    description: 'Batches Grid (All Statuses) > Batch Status - Generating',
    defaultMessage: 'Generating',
    id: 'VsT7Vi',
  },
  completedStatus: {
    description: 'Batches Grid (All Statuses) > Batch Status - Completed',
    defaultMessage: 'Completed',
    id: 'EZ/c2k',
  },
  notifyingMarketplaceStatus: {
    description: 'Batches Grid (All Statuses) > Batch Status - Notifying Marketplace',
    defaultMessage: 'Notifying Marketplace',
    id: 'IPFRIP',
  },
  sendingEmailsStatus: {
    description: 'Batches Grid (All Statuses) > Batch Status - Sending Emails',
    defaultMessage: 'Sending Emails',
    id: 'MXChTK',
  },
  invalidStatus: {
    description: 'Batches Grid (All Statuses) > Batch Status - Invalid',
    defaultMessage: 'Invalid',
    id: 'fTVgW2',
  },
  undefinedStatus: {
    description: 'Batches Grid (All Statuses) > Batch Status - Undefined',
    defaultMessage: 'Undefined',
    id: 'FU/LEr',
  },
  archivedStatus: {
    description: 'Batches Grid (All Statuses) > Batch Status - Archived',
    defaultMessage: 'Archived',
    id: 'hOBZzz',
  },
});

const statusToDescriptor = {
  [BATCH_STATUS_OPEN]: messages.openStatus,
  [BATCH_STATUS_QUEUED]: messages.queuedStatus,
  [BATCH_STATUS_PROCESSING]: messages.processedStatus,
  [BATCH_STATUS_GENERATING]: messages.generatingStatus,
  [BATCH_STATUS_COMPLETED]: messages.completedStatus,
  [BATCH_STATUS_NOTIFYING_MARKETPLACE]: messages.notifyingMarketplaceStatus,
  [BATCH_STATUS_SENDING_EMAILS]: messages.sendingEmailsStatus,
  [BATCH_STATUS_INVALID]: messages.invalidStatus,
  [BATCH_STATUS_ARCHIVED]: messages.archivedStatus,
};

export const messageDescriptionFromBatchStatus = (batchStatus) => {
  if (!statusToDescriptor[batchStatus]) {
    return messages.undefinedStatus;
  }
  return statusToDescriptor[batchStatus];
};
